import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Separator.scss';

const Separator = ({ content }) => {
	return <div className={s.separator} />;
};

export default hot(module)(Separator);
